export const asFirstName = (displayName: string): string => displayName.split(" ")[0];
